<template>
  <div class="h-screen">
    <div class="absolute inset-0 flex items-center justify-center z-10">
      <div class="bg-white rounded-[20px] p-8 max-w-80 md:max-w-96">
        <h1 class="text-display1 pb-6">
          {{ t("lockscreen.title") }}
          <i class="italic">{{ t("lockscreen.subtitle") }}</i>
        </h1>
        <div class="text-small pb-1">{{ t("lockscreen.teaser") }}</div>
        <div class="text-large pb-6">{{ t("lockscreen.headline") }}</div>
        <div class="text-lg leading-snug whitespace-pre-line">
          <span v-html="t('lockscreen.text').replace(/&#58;/g, ':')"></span>
        </div>
      </div>
    </div>
    <LockScreenBackgroundDesktop class="object-cover mx-auto hidden md:block" />
    <LockScreenBackgroundMobile class="object-cover mx-auto block md:hidden" />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import LockScreenBackgroundDesktop from "../../components/v2/icon/LockScreenBackgroundDesktop.vue";
import LockScreenBackgroundMobile from "../../components/v2/icon/LockScreenBackgroundMobile.vue";

const { t } = useI18n();
</script>
